import { Box, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import logoDark from "../../../assets/images/logo-dark.png";

type TLogo = {
  className: string;
  size: number;
};

export default function HmisLogo(
  props: TLogo = { className: "logo", size: 38 },
) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const dashboardClick = () => {
    navigate("/dashboard");
  };

  return (
    <>
      <Box className={props.className} onClick={dashboardClick}>
        <img
          src={isDark ? logoDark : logo}
          style={{ height: `${props.size}px`, width: "auto" }}
          alt="Hims Logo"
        />
      </Box>
    </>
  );
}
